import { useEffect, useState } from 'react';
import barcode_image from '../../../../../assets/media/barcode-scan.png';
import { TYPE_BUTTONS } from '../../../../../constans';
import { PopUp, Row } from '../../../../Basic/Blocks';
import { Button } from '../../../../Basic/Buttons';
import { Icon } from '../../../../Basic/Elements';
import { Input } from '../../../../Basic/Inputs';
import { H2 } from '../../../../Basic/WrapsStyle';
import styles from './styles.module.scss';


const BarcodePopUp = ({ product = {}, onPrint = () => { }, noAdd, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    // const [barcodeQuantity, setBarcodeQuantity] = useState(1);
    const [productQuantity, setProductQuantity] = useState(1);

    useEffect(() => {
        setProductQuantity(product.ordered_quantity - product.processed_quantity)
        // setBarcodeQuantity(product.ordered_quantity - product.processed_quantity)
    }, [product]);


    return (
        <div>
            <Row>
                <Button
                    style={{
                        marginRight: '10px',
                        // ...(product.ordered_quantity - product.processed_quantity === 0 && { opacity: 0.6 }) 
                    }}
                    disabled={!product?.barcode || (product.ordered_quantity - product.processed_quantity === 0) || (product.ordered_quantity - product.processed_quantity - productQuantity < 0)}
                    // disabled={!product?.barcode || (product.ordered_quantity === product.processed_quantity)}
                    type={TYPE_BUTTONS.WHITE}
                    className={styles.white_button}
                    // onClick={() => setIsOpen(true)}>
                    onClick={() => onPrint({ offerId: product.offer_id, shop: product.shop, supplyId: product.supply_id, productQuantity: +productQuantity, barcodeQuantity: +productQuantity, noAdd, boxId: product._id })}>
                    <Icon src={barcode_image} width="35px" />
                </Button>
                <Input
                    // updateValue={{}}
                    center={true}
                    value={productQuantity}
                    // onClickEnter={(v) => setProductQuantity(v)}
                    // onBlur={(v) => setProductQuantity(v)}
                    onChange={(v) => setProductQuantity(v)}
                />
            </Row>

            {isOpen && (
                <PopUp close={() => setIsOpen(false)} clickOutside={false}
                    style={{ minWidth: '450px', }}
                >
                    <H2 style={{ marginBottom: '10px' }}>{`Сколько нужно  ${product.offer_id}?`}</H2>
                    {/* {card.warehouse_stock && (
                        <Row>
                            <div style={{ marginRight: '20px' }}>На складе: {card.warehouse_stock}</div>
                            <div style={{ marginRight: '20px' }}>В карточке: {card.quantity}</div>
                            <div>Доступно: {Math.floor(card.warehouse_stock / card.quantity)}</div>
                        </Row>
                    )} */}
                    <Row>
                        <Input width='140px' label="Количество этикеток" value={barcodeQuantity} onChange={(v) => setBarcodeQuantity(v)} />
                        <Input style={{ marginLeft: '20px' }} width='140px' label="Количество товаров" value={productQuantity} onChange={(v) => setProductQuantity(v)} />
                    </Row>
                    <Row style={{ marginTop: '30px', }}>
                        <Button
                            type={TYPE_BUTTONS.BLUE}
                            style={{ marginRight: '20px' }}
                            onClick={() => {
                                onPrint({ offerId: product.offer_id, productQuantity: +productQuantity, barcodeQuantity: +barcodeQuantity, noAdd, boxId: product._id })
                                setIsOpen(false)
                            }}
                        // disabled={!Number.isInteger(+productQuantity) || +productQuantity <= 0 || +productQuantity > Math.floor(card.warehouse_stock / card.quantity)}
                        >
                            Печать
                        </Button>
                        <Button type={TYPE_BUTTONS.GREY} onClick={() => setIsOpen(false)}>
                            Отменить
                        </Button>
                    </Row>
                </PopUp>
            )
            }
        </div >
    );
};

export default BarcodePopUp;
